import React, { Fragment, Component } from 'react'
import PropTypes from 'prop-types'
import { Row, Col } from 'react-flexbox-grid'
import { GlgButton, GlgSwitch } from 'SharedComponents'

class FooterSectionComponent extends Component {

  render(){
    const {
      isVisible,
      toggleVisible,
      changeViewDisplayed,
    } = this.props

    return (
      <Fragment>
        <Row className='vertical-align-items'>
          <Col className='no-padding-left no-margin-top' xs={ 12 } sm={ 8 }>
            { !window.I18n ? '' : window.I18n.t('tv_shows.components.footer_section_component.customize') }
          </Col>
          <Col className='no-padding-left' xs={ 6 } sm={ 2 }>
            <GlgSwitch
              id='footer-visible-switch'
              text={ [ (!window.I18n ? '' : window.I18n.t('tv_shows.components.footer_section_component.visible')),
                        (!window.I18n ? '' : window.I18n.t('tv_shows.components.footer_section_component.hidden')) ] }
              widthInPixels={ 80 }
              checked={ isVisible }
              onChange={ toggleVisible } />
          </Col>
          <Col className='no-padding-left' xs={ 6 } sm={ 2 }>
            <GlgButton
              text={ !window.I18n ? '' : window.I18n.t('buttons.edit') }
              icon="pencil"
              color="white"
              onClick={ () => changeViewDisplayed('footerSettings') } />
          </Col>
        </Row>
      </Fragment>
    )
  }
}

FooterSectionComponent.propTypes = {
  isVisible: PropTypes.bool.isRequired,
  toggleVisible: PropTypes.func.isRequired,
  changeViewDisplayed: PropTypes.func.isRequired,
}

export default FooterSectionComponent
